import { useEffect } from 'react';

const useDocumentTitle = (title) =>
  useEffect(() => {
    if (typeof title === 'string' && title) document.title = title;
  }, []);

export default useDocumentTitle;
